import { Link, Navigate } from 'react-router-dom'
import { Building2 } from 'lucide-react'
import type { MeAccount } from '@impulso/shared'
import { useSession } from '../../lib/session'
import { getLastCompany } from '../../lib/last-company'
import { Loading, PageHead } from '../../ui'

type MeCompany = MeAccount['companies'][number]
const isAgencyView = (a: MeAccount) => a.kind === 'agency' && a.permissions.length > 0
const companyHome = (c: MeCompany) => (!c.onboardingCompleted && c.role === 'manager' ? `/app/${c.id}/onboarding` : `/app/${c.id}/inicio`)

/** /app: leva o usuário para o lugar certo (criar conta, última empresa usada, visão da agência, onboarding ou início). */
export default function AppHome() {
  const { me, loading } = useSession()
  if (loading) return <Loading />
  const accounts = me?.accounts ?? []
  if (!accounts.length) return <Navigate to={me?.user.isStaff ? '/admin' : '/criar-conta'} replace /> // equipe interna não tem conta de cliente

  const last = getLastCompany()
  const lastOwner = accounts.find((a) => a.companies.some((c) => c.id === last))
  if (lastOwner && !isAgencyView(lastOwner)) return <Navigate to={companyHome(lastOwner.companies.find((c) => c.id === last)!)} replace />

  const total = accounts.reduce((n, a) => n + a.companies.length, 0)
  if (accounts.length === 1 && (total <= 1 || isAgencyView(accounts[0]!) || !accounts[0]!.companies.length)) {
    const account = accounts[0]!
    if (isAgencyView(account)) return <Navigate to="/app/agencia" replace />
    const company = account.companies[0]
    return <Navigate to={company ? companyHome(company) : `/app/conta/${account.id}/empresas`} replace />
  }

  // Mais de uma conta ou empresa e nada lembrado: a pessoa escolhe
  return (
    <div className="stack" style={{ gap: 20 }}>
      <PageHead title="Qual empresa você quer abrir?" sub="Da próxima vez abrimos direto a última que você usou." />
      <div className="list">
        {accounts.map((a) => (
          <div key={a.id} className="card stack" style={{ gap: 10 }}>
            <h2>{a.name}</h2>
            {isAgencyView(a) && <Link className="btn sm" style={{ alignSelf: 'flex-start' }} to="/app/agencia"><Building2 size={15} /> Visão dos clientes</Link>}
            {a.companies.map((c) => (
              <Link key={c.id} className="list-item" to={companyHome(c)}>
                <span className="strong">{c.name}</span>
              </Link>
            ))}
            {!a.companies.length && <p className="small muted">Nenhuma empresa nesta conta ainda.</p>}
          </div>
        ))}
      </div>
    </div>
  )
}
